import React from 'react'
import MySlider from "../MySlider";
import {GenericSlider} from '../MySlider'
import ImageAspectRatio from '../shop/utils/ImageAspectRatio';
import alfonsichisiamo from '../../images/alfonsi-chisiamo.jpg'
import TitleCaptionDescription from './TitleCaptionDescription'
import IscrivitiFrame from '../MainComponents/IscrivitiFrame';

export default function IndexPage() {
    let immagini=[{file:"/images/home-slide1.png",alt:""},{file:"/images/home-slide2.png",alt:""}
    ,{file:"/images/home-slide3.png",alt:""}]
    window.scrollTo(0, 0)
    return (
        <div className="container" style={{paddingLeft:"0",paddingRight:"0"}}>
            <div style={{padding:"15px 0"}}>
                <div>
                <GenericSlider arrows={false} dots={true}>
                    {immagini.map((immagine,i)=>{
                        return(
                            <div key={i}>
                                <img style={{width:"100%"}} src={immagine.file} alt={immagine.alt}/>
                            </div> 
                        )
                    })}
                </GenericSlider>
                </div>
            </div>
            <div style={{padding:"15px"}}>
                <div className="row" style={{marginTop:"45px"}}>
                    <div className="col-lg-6 col-md-6 col-sm-12 d-none d-md-block immagine-background" style={{padding:"0"}} >
                        <img src={alfonsichisiamo} style={{maxWidth:"100%"}} alt=""/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <TitleCaptionDescription title={"Riccardo Alfonsi"} caption={"Orafo"}>
                        <div>
                        
                        Sono figlio d'arte, questa eredità nel corso della mia carriera mi ha dato una grande responsabilità verso i miei maestri, in primo luogo mio padre ma anche riguardo a delle conoscenze tramandate nella storia delle <b>botteghe artigiane</b> che sono le ricchezze della nostra storia. <br/>
                        Questo mio bagaglio lo trasferisco su delle <b>creazioni</b> che fondono le tecniche classiche all'<b>artigianato artistico</b> a un pensiero tutto mio che trasferisco su un disegno dalle linee contemporanee ma non necessariamente omologate.<br/><br/>
                        Le <b>mie opere</b> sono destinate ad un pubblico che ricerca un <b>gioiello</b> personalizzato preferibilmente unico e che vuole distinguersi.
                        </div>
                    </TitleCaptionDescription>

                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 immagine-background d-md-none" style={{padding:"0",marginTop:"15px"}} >
                        <img src={alfonsichisiamo} style={{maxWidth:"100%"}} alt=""/>
                    </div>
                </div>
            </div>
            {/* <IscrivitiFrame></IscrivitiFrame> */}
        </div>
    )
}
